export var tableLayers = [{
  id: 'GenericTable',
  type: 'order',
  action: 'tableColumnOrder',
  event: true,
  contextualize: function contextualize(_ref) {
    var orderParams = _ref.orderParams,
      column = _ref.column;
    return {
      column: {
        id: column.uniqueId,
        label: column.component
      },
      type: orderParams.type
    };
  }
}, {
  id: 'GenericTable',
  type: 'filter',
  action: 'tableColumnFilter',
  event: true,
  contextualize: function contextualize(_ref2) {
    var filterParams = _ref2.filterParams,
      column = _ref2.column;
    return {
      column: {
        id: column.uniqueId,
        label: column.component
      },
      value: filterParams.value
    };
  }
}, {
  id: 'ProductsTable',
  type: 'tableColumnsChange',
  action: 'tableColumnsChange',
  name: 'table',
  model: 'column',
  event: true,
  modelize: function modelize(_ref3) {
    var columns = _ref3.columns;
    return columns;
  }
}, {
  id: 'ProductsTable',
  type: 'customization',
  action: 'tableOpenColumnsCustomization',
  event: true
}];